// removed by extract-text-webpack-plugin
module.exports = {"type-changer":"type-changer__type-changer","type":"type-changer__type","type-changer-pop-up":"type-changer__type-changer-pop-up"};


//////////////////
// WEBPACK FOOTER
// ./src/components/data-pane/type-changer.scss
// module id = 1213
// module chunks = 0